const nameEntity = 'InvoiceIssuedForCnpj'
const nameSource = 'invoicesIssuedForCnpj'

export { nameEntity, nameSource }
